

export const FETCH_PROPERTY_TYPE_TEMPLATES_REQUEST = 'propertyTypeTemplates/FETCH_PROPERTY_TYPE_TEMPLATES_REQUEST';
export const FETCH_PROPERTY_TYPE_TEMPLATES_SUCCESS = 'propertyTypeTemplates/FETCH_PROPERTY_TYPE_TEMPLATES_SUCCESS';
export const FETCH_PROPERTY_TYPE_TEMPLATES_FAILURE = 'propertyTypeTemplates/FETCH_PROPERTY_TYPE_TEMPLATES_FAILURE';


export const FETCH_PROPERTY_TYPE_TEMPLATE_REQUEST = 'propertyTypeTemplates/FETCH_PROPERTY_TYPE_TEMPLATE_REQUEST';
export const FETCH_PROPERTY_TYPE_TEMPLATE_SUCCESS = 'propertyTypeTemplates/FETCH_PROPERTY_TYPE_TEMPLATE_SUCCESS';
export const FETCH_PROPERTY_TYPE_TEMPLATE_FAILURE = 'propertyTypeTemplates/FETCH_PROPERTY_TYPE_TEMPLATE_FAILURE';


export const DELETE_PROPERTY_TYPE_TEMPLATE_REQUEST = 'propertyTypeTemplates/DELETE_PROPERTY_TYPE_TEMPLATE_REQUEST';
export const DELETE_PROPERTY_TYPE_TEMPLATE_SUCCESS = 'propertyTypeTemplates/DELETE_PROPERTY_TYPE_TEMPLATE_SUCCESS';
export const DELETE_PROPERTY_TYPE_TEMPLATE_FAILURE = 'propertyTypeTemplates/DELETE_PROPERTY_TYPE_TEMPLATE_FAILURE';


export const CREATE_PROPERTY_TYPE_TEMPLATE_REQUEST = 'propertyTypeTemplates/CREATE_PROPERTY_TYPE_TEMPLATE_REQUEST';
export const CREATE_PROPERTY_TYPE_TEMPLATE_SUCCESS = 'propertyTypeTemplates/CREATE_PROPERTY_TYPE_TEMPLATE_SUCCESS';
export const CREATE_PROPERTY_TYPE_TEMPLATE_FAILURE = 'propertyTypeTemplates/CREATE_PROPERTY_TYPE_TEMPLATE_FAILURE';


export const UPDATE_PROPERTY_TYPE_TEMPLATE_REQUEST = 'propertyTypeTemplates/UPDATE_PROPERTY_TYPE_TEMPLATE_REQUEST';
export const UPDATE_PROPERTY_TYPE_TEMPLATE_SUCCESS = 'propertyTypeTemplates/UPDATE_PROPERTY_TYPE_TEMPLATE_SUCCESS';
export const UPDATE_PROPERTY_TYPE_TEMPLATE_FAILURE = 'propertyTypeTemplates/UPDATE_PROPERTY_TYPE_TEMPLATE_FAILURE';


export const UPDATE_FIELD = 'propertyTypeTemplates/UPDATE_FIELD';
export const SET_DEFAULT_DATA = 'propertyTypeTemplates/SET_DEFAULT_DATA';
